import { BaseLayerType } from "esdm-map";
import { BaseMap, MapSettings } from "../defs/MapSettings";
import { LhlpBaseLayers } from "./LhlpBaseLayerFactory";

/**
 *  Converts the Tenant base layers into the correct enum for each base layer
 *  */
export class TenantSettingsBaseLayerResolver {


    public constructor(
        private _mapSettings: MapSettings
    ){}

    public getBaseLayerTypes = (): BaseLayerType[] => {
        let types = new Array<BaseLayerType>();

        let sortedBaselayers = this._mapSettings.BaseMaps.sort((a, b) => (a.Order > b.Order ? 1 : -1));
        sortedBaselayers.forEach(function (map: BaseMap) {
            //NB
            //Add any new enumerations to the help in LHL.Core.Configuration.TenantSettingsDefault & the XSD
            switch (map.BaseMapType) {
                case "BingAerial":
                    types.push(LhlpBaseLayers.BingAerial);
                    break;

                case "BingOS":
                    types.push(LhlpBaseLayers.BingOS);
                    break;

                case "OSM_ESDM_contours":
                    types.push(LhlpBaseLayers.OSM_ESDM_contours);
                    break;

                case "OrdnanceSurvey_1937to1961":
                    types.push(LhlpBaseLayers.OrdnanceSurvey_1937to1961);
                    break;

                case "OrdnanceSurvey_1900":
                    types.push(LhlpBaseLayers.OrdnanceSurvey_1900);
                    break;

                case "Buckinghamshire_OS":
                    types.push(LhlpBaseLayers.Buckinghamshire_OS);
                    break;

                case "SouthYorkshire_OS":
                    types.push(LhlpBaseLayers.SouthYorkshire_OS);
                    break;

                case "Cheshire_OS":
                    types.push(LhlpBaseLayers.Cheshire_OS);
                    break;

                case "Merseyside_OS":
                    types.push(LhlpBaseLayers.Merseyside_OS);
                    break;
            }

        });

        return types;
   }

}